export default "__VITE_ASSET__54497164__"